import { render, staticRenderFns } from "./alarm-header-priority.vue?vue&type=template&id=7fe540be&scoped=true&"
var script = {}
import style0 from "./alarm-header-priority.vue?vue&type=style&index=0&id=7fe540be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe540be",
  null
  
)

export default component.exports